import { ApolloClient, ApolloLink } from "@apollo/client";

import { cache } from "./cache";
import { errorLink } from "./links/errorLink";
import { uploadLink } from "./links/uploadLink";

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, uploadLink]),
  cache,
});
